/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMessage } from './APIMessage';
import {
    APIMessageFromJSON,
    APIMessageFromJSONTyped,
    APIMessageToJSON,
} from './APIMessage';

/**
 * 
 * @export
 * @interface APIPaginatedMessageList
 */
export interface APIPaginatedMessageList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedMessageList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedMessageList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedMessageList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIMessage>}
     * @memberof APIPaginatedMessageList
     */
    results: Array<APIMessage>;
}

/**
 * Check if a given object implements the APIPaginatedMessageList interface.
 */
export function instanceOfAPIPaginatedMessageList(value: object): value is APIPaginatedMessageList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedMessageListFromJSON(json: any): APIPaginatedMessageList {
    return APIPaginatedMessageListFromJSONTyped(json, false);
}

export function APIPaginatedMessageListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedMessageList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIMessageFromJSON)),
    };
}

export function APIPaginatedMessageListToJSON(value?: APIPaginatedMessageList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIMessageToJSON)),
    };
}

